export default __webpack_public_path__ + "static/media/working-blob.3af918ac.gif";